import classNames from "classnames";
import { get } from "lodash";
import { MdCheck, MdInfoOutline } from "react-icons/md";
import Button from "../../Components/Button";
import Cost from "../../Components/Cost";

const ProductCard = ({
  icon,
  name,
  description,
  price,
  action,
  info,
  link,
  recommendation,
  showGuarantee,
}) => {
  return (
    <div className="product--item">
      <div
        className={classNames({
          "recommended--product": recommendation?.value,
        })}
      >
        <div className="product--item--wrapper">
          <div className="product--item--header">
            <div className="product--item--header--top">
              <span className="--name">{name}</span>
              {recommendation?.value && (
                <span className="product--item--tag">
                  {recommendation?.label}
                </span>
              )}
            </div>
            <Cost
              cost={get(price, "cost")}
              currency={get(price, "currency")}
              showYearly
            />
            <p className="product--item--description">{description}</p>
          </div>
          <div className="product--item--action">
            <Button
              type={recommendation?.value ? "primary" : "primary-light"}
              onClick={action?.onClick}
              loading={action?.loading}
              disabled={action?.disabled}
            >
              {action?.label}
            </Button>
          </div>
          <div className="product--item--info">
            <span className="product--item--info--title">{info?.title}</span>

            <div className="product--item--info--list">
              {get(info, "items", []).map((item, i) => (
                <div key={i} className="item">
                  <MdCheck size={20} />
                  <div className="content">{item.mainInfo}</div>
                  <MdInfoOutline
                    onClick={() => showGuarantee(item)}
                    size={20}
                    color="#808080"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="product--item--link" onClick={link?.onClick}>
            {link?.label}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
